import moment from 'moment';
import * as calendarConsts from '../constants/calendar-constants';

export const getUserDate = (offsetHours, formatVal) => {
  return moment().clone().utcOffset(offsetHours).format(formatVal);
};

export const getSelectedDateRange = (value, mode) => {
  const momentDateObj = value.utc(false).clone();

  switch (mode) {
    case calendarConsts.YEAR_MODE:
      return [momentDateObj.startOf('year').clone(), momentDateObj.endOf('year').clone()];

    case calendarConsts.MONTH_MODE:
      const [first, last] = [momentDateObj.startOf('month').clone(), momentDateObj.endOf('month').clone()];

      const daysInMonth = momentDateObj.daysInMonth();
      const before = first.day();
      const after = 42 - daysInMonth - before;

      return [first.subtract(before, 'days').clone(), last.add(after, 'days').clone()];

    case calendarConsts.DAY_MODE:
      return [momentDateObj.startOf('day').clone(), momentDateObj.endOf('day').clone()];

    case calendarConsts.WEEK_MODE:
      return [momentDateObj.startOf('week').clone(), momentDateObj.endOf('week').clone()];

    case calendarConsts.TIMELINE_MODE:
      return [momentDateObj.clone().subtract(1, 'day').startOf('date'), momentDateObj.clone().add(1, 'day').endOf('date')];
  }
};
